import { batch } from 'react-redux';
import yousersjs from '@yola/yousersjs';
import status from 'src/js/modules/status';
import statusNames from 'src/js/modules/user/constants/status-names';
import resolveServiceError from 'src/js/common/helpers/resolve-service-error';
import { snakeCaseObjectToCamelCase } from 'src/js/utils/convert-case';
import user from 'src/js/modules/user';

const changeEmail = (email) => async (dispatch) => {
  try {
    dispatch(status.actions.setStatus(statusNames.UPDATE_EMAIL, status.constants.LOADING));
    const responseData = await yousersjs.requests.changeEmail({ email });
    const { isEmailVerified } = snakeCaseObjectToCamelCase(responseData);

    batch(() => {
      dispatch(user.actions.updateUserData('email', email));
      dispatch(user.actions.updateUserData('isEmailVerified', isEmailVerified));
      dispatch(status.actions.setStatus(statusNames.UPDATE_EMAIL, status.constants.SUCCEEDED));
    });

    return { email, isEmailVerified };
  } catch (e) {
    const error = await resolveServiceError(e);
    dispatch(status.actions.setStatus(statusNames.UPDATE_EMAIL, status.constants.FAILED));
    throw error;
  }
};

export default changeEmail;
